import './success.css'

export function Success() {
  return (
    <div className="success-container">
      <h1 className="success-header">Success!</h1>
      <p className="success-description">
        Thank you for subscribing to receive text notifications for MIT’s {new Date().getFullYear()} Commencement ceremonies. You will receive a text message soon asking to confirm your subscription.
      </p>
      <p className="success-description">Was this a mistake?</p>
      <a className="resubscribe" href="/unsubscribe">
        Unsubscribe
      </a>
    </div>
  )
}
